import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface SessionTitlesState {
  titles: Record<string, string>;
  sync: (sessions: { id: string; title: string }[]) => void;
  get: (id: string) => string | undefined;
}

export const useSessionTitlesStore = create<SessionTitlesState>()(
  persist(
    (set, get) => ({
      titles: {},
      sync: (sessions) =>
        set({
          titles: Object.fromEntries(sessions.map((s) => [s.id, s.title])),
        }),
      get: (id) => get().titles[id],
    }),
    {
      name: 'session-titles',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ titles: state.titles }),
    },
  ),
);
